export const isValidStudioOrigin = (origin?: string) => {
  const allowedOriginRegexes = /^(https:\/\/[a-zA-Z0-9-.]+\.commandbar\.com|http:\/\/localhost:4000)$/;
  return !!origin && origin.match(allowedOriginRegexes);
};
